export const supportedLanguages = [
	'fr'
];
